import useToggle from '@lyearn/core/hooks/useToggle';

import { RestrictedVisibilitySettingsContentProps } from '../types';

export const useRestrictedVisibilitySettingsContent = (
  props: Pick<RestrictedVisibilitySettingsContentProps, 'value' | 'getCountLabel'>,
) => {
  const [isModalOpen, { on: onOpenModal, off: onCloseModal, toggle: toggleModal }] = useToggle();
  const { value, getCountLabel } = props;

  return {
    countLabel: getCountLabel?.(value),
    onOpenModal,
    onCloseModal,
    isModalOpen,
    toggleModal,
  };
};
